import React from "react";
import Clock from "../components/Clock";

export default function ClockPage() {
  return (
    <div>
      <Clock />
    </div>
  );
}
